export const articleDetail = {
  id: '1',
  title: '某顶流艺人深夜密会神秘女子 酒店共度8小时全程被拍',
  summary: '据知情人士透露，该艺人近期正处于新剧宣传期，此次密会事件或将对品牌代言产生重大影响。',
  category: '热门大瓜',
  categorySlug: 'remen-dagua',
  imageUrl: 'https://readdy.ai/api/search-image?query=Celebrity%20paparazzi%20night%20scene%20luxury%20hotel%20entrance%20mysterious%20silhouette%20dramatic%20lighting%20warm%20amber%20tones%20cinematic%20mood%20editorial%20photography%20soft%20shadows%20high%20contrast%20elegant%20composition&width=1200&height=675&seq=article-detail-01&orientation=landscape',
  publishedAt: '2026-06-28T14:30:00',
  author: '吃瓜前线记者',
  views: 1280000,
  comments: 5600,
  content: `<p>近日，有媒体拍到某顶流男艺人在深夜时分独自驾车前往某高端酒店，随后一名神秘女子现身并与该艺人一同进入酒店。据现场记者描述，该艺人与神秘女子在酒店内共度约8小时后，于次日清晨分别离开。</p>
  <p>据知情人士透露，该艺人近期正处于新剧宣传期，多个品牌代言合约正在洽谈中。此次密会事件曝光后，或将对其商业价值产生重大影响。</p>
  <p>目前，该艺人及其工作室尚未对此事作出公开回应。粉丝群体出现分歧，部分粉丝表示"相信偶像"，也有粉丝对艺人的行为表示失望。</p>
  <p>业内人士分析认为，在当今社交媒体时代，艺人的私生活越来越难以隐藏。尤其是处于事业上升期的艺人，更应该谨言慎行，避免不必要的负面新闻影响事业发展。</p>
  <p>本网将持续关注此事件的后续发展，敬请期待更多独家爆料。</p>`,
  tags: ['顶流艺人', '密会', '酒店', '恋情曝光', '独家爆料'],
  relatedArticles: [
    {
      id: '2',
      title: '知名企业家被曝财务造假 涉案金额高达50亿 官方已介入调查',
      imageUrl: 'https://readdy.ai/api/search-image?query=Corporate%20scandal%20investigation%20office%20documents%20dramatic%20lighting%20warm%20dark%20tones%20editorial%20photography&width=400&height=300&seq=related-02&orientation=landscape',
      category: '黑料曝光',
    },
    {
      id: '3',
      title: '网红情侣分手内幕曝光：第三者插足、财产纠纷、互爆猛料',
      imageUrl: 'https://readdy.ai/api/search-image?query=Couple%20breakup%20dramatic%20scene%20split%20screen%20warm%20lighting%20editorial%20photography&width=400&height=300&seq=related-03&orientation=landscape',
      category: '热门大瓜',
    },
  ],
};

export const categoryArticles: Record<string, {
  id: string;
  title: string;
  summary: string;
  imageUrl: string;
  views: number;
  comments: number;
  category?: string;
}[]> = {
  'remen-dagua': [
    {
      id: '1',
      title: '某顶流艺人深夜密会神秘女子 酒店共度8小时全程被拍',
      summary: '据知情人士透露，该艺人近期正处于新剧宣传期，此次密会事件或将对品牌代言产生重大影响。',
      imageUrl: 'https://readdy.ai/api/search-image?query=Celebrity%20paparazzi%20night%20scene%20luxury%20hotel%20dramatic%20lighting%20warm%20tones%20cinematic%20editorial%20photography&width=800&height=600&seq=cat-hot-01&orientation=landscape',
      views: 1280000,
      comments: 5600,
    },
    {
      id: '3',
      title: '网红情侣分手内幕曝光：第三者插足、财产纠纷、互爆猛料',
      summary: '曾经甜蜜的百万粉丝情侣档突然宣布分手，双方在社交平台隔空互撕。',
      imageUrl: 'https://readdy.ai/api/search-image?query=Couple%20breakup%20drama%20split%20screen%20warm%20cinematic%20lighting%20editorial%20photography&width=800&height=600&seq=cat-hot-03&orientation=landscape',
      views: 850000,
      comments: 6200,
    },
    {
      id: '7',
      title: '娱乐圈某夫妻被曝已分居半年 双方工作室保持沉默',
      summary: '有媒体拍到两人已多月未同框，各自忙于工作，婚姻状况引发猜测。',
      imageUrl: 'https://readdy.ai/api/search-image?query=Celebrity%20couple%20separate%20lives%20dramatic%20contrast%20warm%20moody%20lighting%20editorial%20photography&width=800&height=600&seq=cat-hot-07&orientation=landscape',
      views: 520000,
      comments: 2800,
    },
  ],
  expose: [
    {
      id: '2',
      title: '知名企业家被曝财务造假 涉案金额高达50亿 官方已介入调查',
      summary: '多家权威媒体联合报道，该企业财报存在重大疑点，监管部门已成立专案组。',
      imageUrl: 'https://readdy.ai/api/search-image?query=Corporate%20scandal%20documents%20dramatic%20moody%20lighting%20warm%20dark%20tones%20editorial%20photography&width=800&height=600&seq=cat-expose-02&orientation=landscape',
      views: 960000,
      comments: 4300,
    },
    {
      id: '8',
      title: '直播圈潜规则大起底：刷单、数据造假、阴阳合同',
      summary: '业内人士爆料直播行业乱象，揭秘平台与主播之间的灰色产业链。',
      imageUrl: 'https://readdy.ai/api/search-image?query=Dark%20secrets%20revealed%20live%20streaming%20industry%20shadowy%20figures%20warm%20dramatic%20lighting%20editorial&width=800&height=600&seq=cat-expose-08&orientation=landscape',
      views: 780000,
      comments: 5100,
    },
    {
      id: '9',
      title: '知名餐饮品牌后厨卫生黑幕曝光：过期食材、蟑螂乱爬',
      summary: '暗访记者潜伏三个月拍到的惊人画面，该品牌多家门店存在严重卫生问题。',
      imageUrl: 'https://readdy.ai/api/search-image?query=Dark%20restaurant%20kitchen%20investigation%20dirty%20conditions%20moody%20dramatic%20lighting%20warm%20dark%20tones%20editorial%20photography%20hidden%20camera%20style&width=800&height=600&seq=cat-expose-09&orientation=landscape',
      views: 1340000,
      comments: 9200,
    },
  ],
  competition: [
    {
      id: '5',
      title: '选秀节目黑幕录音曝光 导师暗示选手"懂得都懂"引发轩然大波',
      summary: '一段疑似选秀节目后台录音在网络疯传，节目组紧急回应。',
      imageUrl: 'https://readdy.ai/api/search-image?query=Talent%20show%20stage%20dramatic%20spotlight%20warm%20lighting%20cinematic%20editorial%20photography&width=800&height=600&seq=cat-comp-05&orientation=landscape',
      views: 750000,
      comments: 5100,
    },
    {
      id: '10',
      title: '本周瓜王争霸：三大顶流事件终极PK 谁能夺得瓜王宝座',
      summary: '本周三大热门事件进入最终投票阶段，吃瓜群众热情高涨。',
      imageUrl: 'https://readdy.ai/api/search-image?query=Dramatic%20competition%20stage%20three%20spotlights%20golden%20trophy%20warm%20theatrical%20lighting%20editorial%20photography&width=800&height=600&seq=cat-comp-10&orientation=landscape',
      views: 980000,
      comments: 7300,
    },
  ],
  event: [
    {
      id: '4',
      title: '某平台头部主播偷税漏税被罚2.8亿 直播间已被永久封禁',
      summary: '税务部门公布最新稽查结果，该主播已被依法处理。',
      imageUrl: 'https://readdy.ai/api/search-image?query=Empty%20streaming%20studio%20dark%20abandoned%20warm%20moody%20atmosphere%20editorial%20photography&width=800&height=600&seq=cat-event-04&orientation=landscape',
      views: 2100000,
      comments: 8900,
    },
    {
      id: '6',
      title: '某女星与前经纪公司解约官司胜诉 获赔3000万并恢复自由身',
      summary: '历经两年诉讼，该女星终于赢得解约官司。',
      imageUrl: 'https://readdy.ai/api/search-image?query=Celebrity%20courthouse%20victory%20confident%20warm%20sunlight%20editorial%20photography&width=800&height=600&seq=cat-event-06&orientation=landscape',
      views: 620000,
      comments: 3400,
    },
  ],
  '51online': [
    {
      id: '51-1',
      title: '51吃瓜入口今日更新：新增高清资源频道 吃瓜体验全面升级',
      summary: '51在线入口今日迎来重大更新，新增高清资源专属频道，吃瓜群众可以享受更流畅的浏览体验。',
      imageUrl: 'https://readdy.ai/api/search-image?query=Digital%20portal%20gateway%20futuristic%20interface%20warm%20amber%20accents%20modern%20clean%20design%20editorial%20photography%20high%20detail&width=800&height=600&seq=cat-51-01&orientation=landscape',
      views: 560000,
      comments: 2100,
      category: '51在线',
    },
    {
      id: '51-2',
      title: '今日吃瓜合集大更新：一周热门事件精华汇总 收藏党必看',
      summary: '本周吃瓜合集已整理完毕，涵盖娱乐圈、直播圈、商业圈等领域最热门事件，一贴看尽全网大瓜。',
      imageUrl: 'https://readdy.ai/api/search-image?query=Collection%20archive%20organized%20content%20warm%20lighting%20editorial%20design%20neat%20layout%20professional%20photography%20clean%20composition&width=800&height=600&seq=cat-51-02&orientation=landscape',
      views: 430000,
      comments: 1800,
      category: '51在线',
    },
    {
      id: '51-3',
      title: '51在线吃瓜入口速度优化完成 全国CDN加速已部署',
      summary: '为提升全国吃瓜群众访问体验，51在线入口已全面部署CDN加速，加载速度提升300%。',
      imageUrl: 'https://readdy.ai/api/search-image?query=Fast%20speed%20digital%20network%20acceleration%20warm%20glowing%20lines%20modern%20tech%20design%20editorial%20photography%20clean&width=800&height=600&seq=cat-51-03&orientation=landscape',
      views: 320000,
      comments: 1500,
      category: '51在线',
    },
  ],
};

export const categoryMeta: Record<string, { name: string; icon: string; description: string }> = {
  'remen-dagua': {
    name: '热门大瓜',
    icon: 'ri-fire-line',
    description: '全网最火爆的吃瓜事件汇总，实时热度排行，不错过任何一个精彩大瓜。每日更新，第一时间掌握最新动态。',
  },
  expose: {
    name: '黑料曝光',
    icon: 'ri-spy-line',
    description: '独家黑料深度揭秘，还原事件真相。专业团队深入调查，为你呈现不为人知的幕后故事。',
  },
  competition: {
    name: '吃瓜大赛',
    icon: 'ri-trophy-line',
    description: '每日吃瓜大赛精彩对决，投票选出最劲爆大瓜。参与互动，赢取吃瓜达人称号。',
  },
  event: {
    name: '吃瓜事件',
    icon: 'ri-alert-line',
    description: '全网吃瓜事件实时追踪，从娱乐圈到商业圈，全方位覆盖各类热门话题。',
  },
  '51online': {
    name: '51在线',
    icon: 'ri-rocket-line',
    description: '51在线吃瓜入口，最新资源实时更新。吃瓜群众不可错过的终极资源入口，一站式浏览体验。',
  },
};

const articleSummaries = Object.entries(categoryArticles).flatMap(([slug, articles]) =>
  articles.map((article, index) => ({
    ...article,
    categorySlug: slug,
    category: article.category || categoryMeta[slug]?.name || '热门大瓜',
    sortIndex: index,
  })),
);

function buildRelatedArticles(currentId: string) {
  return articleSummaries
    .filter((article) => article.id !== currentId)
    .slice(0, 2)
    .map((article) => ({
      id: article.id,
      title: article.title,
      imageUrl: article.imageUrl,
      category: article.category,
    }));
}

function buildGeneratedContent(title: string, summary: string, category: string) {
  return `<p>${summary}</p>
  <p>围绕「${title}」这一话题，站内持续梳理公开信息、传播脉络和网友关注点，帮助读者快速了解事件重点。</p>
  <p>从当前热度来看，该事件仍在持续发酵，相关讨论集中在事实核验、后续回应和影响范围几个方面。</p>
  <p>更多${category}相关内容会继续在分类页更新，方便吃瓜群众集中浏览。</p>`;
}

export const articleDetails = articleSummaries.map((article, index) => {
  if (article.id === articleDetail.id) {
    return {
      ...articleDetail,
      relatedArticles: buildRelatedArticles(article.id),
    };
  }

  return {
    id: article.id,
    title: article.title,
    summary: article.summary,
    category: article.category,
    categorySlug: article.categorySlug,
    imageUrl: article.imageUrl,
    publishedAt: `2026-06-${String(Math.max(18, 28 - (index % 9))).padStart(2, '0')}T10:00:00`,
    author: '吃瓜前线记者',
    views: article.views,
    comments: article.comments,
    content: buildGeneratedContent(article.title, article.summary, article.category),
    tags: [article.category, '今日吃瓜', '热门事件', '持续关注'],
    relatedArticles: buildRelatedArticles(article.id),
  };
});

export function getArticleById(id?: string) {
  return articleDetails.find((article) => article.id === id) || articleDetails[0];
}
